import React from 'react';

const DumpIcon = ({ size = 24, color = '#000' }) => {
  return (
    <svg
      width={size}
      height={size * (26 / 24)} 
      viewBox="0 0 24 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 6.33333H23M9.25 11.6667V19.6667M14.75 11.6667V19.6667M2.375 6.33333L3.75 22.3333C3.75 23.0406 4.03973 23.7189 4.55546 24.219C5.07118 24.719 5.77065 25 6.5 25H17.5C18.2293 25 18.9288 24.719 19.4445 24.219C19.9603 23.7189 20.25 23.0406 20.25 22.3333L21.625 6.33333M7.875 6.33333V2.33333C7.875 1.97971 8.01987 1.64057 8.27773 1.39052C8.53559 1.14048 8.88533 1 9.25 1H14.75C15.1147 1 15.4644 1.14048 15.7223 1.39052C15.9801 1.64057 16.125 1.97971 16.125 2.33333V6.33333"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DumpIcon;
